.badge {
  display: inline-flex;
  align-items: center;
  gap: var(--space-1);
  padding: var(--space-1) var(--space-2);
  border: 1px solid transparent;
  border-radius: var(--radius-sm);
  font-size: var(--text-xs);
  font-weight: var(--weight-medium);
  line-height: var(--leading-tight);
  white-space: nowrap;
}

.pill {
  border-radius: var(--radius-full);
  padding-inline: var(--space-3);
}

.neutral {
  background: var(--surface-sunken);
  border-color: var(--border);
  color: var(--text-secondary);
}

.positive {
  background: var(--surface-positive);
  color: var(--intent-positive);
}

.warning {
  background: var(--surface-warning);
  color: var(--intent-warning);
}

.danger {
  background: var(--surface-danger);
  color: var(--intent-danger);
}

.info {
  background: var(--surface-sunken);
  color: var(--intent-info);
}

/* Colour is never the only carrier: a dot plus the text carries it too. */
.dot {
  width: var(--space-2);
  height: var(--space-2);
  border-radius: var(--radius-full);
  background: currentColor;
  flex: none;
}
